import { fromEvent } from 'rxjs';

export const onWindowPageHide = fromEvent(window, 'pagehide');
